import React, { useState,useContext,useEffect } from 'react';
import { Label,SelectOption,Select,Alert} from '@americanexpress/dls-react';
import { RadioButton } from '@americanexpress/dls-react';
import {
    Modal, ModalBody, ModalFooter, Button
} from '@americanexpress/dls-react';
import userContext from '../../components/ContextComponent/UserContext';

function RelativeOfDirector() {
    const [show, setShow] = useState(false);
    const showModal = (e) => { e.preventDefault();  setShow(true) };
    const closeModal = () => setShow(false);
    const { formData, setFormData } = useContext(userContext);
    const { errorData, setErrorData} = useContext(userContext);

    const valueChange = (event) => {
        if (event.target.value === '')
            setErrorData({ ...errorData, relOfDirectorRequired: true });
        else
            setErrorData({ ...errorData, relOfDirectorRequired: false });

        setFormData({ ...formData, relOfDirector: event.target.value });
    };

    const [options, setOptions] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            const result = await fetch(`/api/content/BankOrDirector`)
                .then(response => response.json())
                .then(json => json);
            setOptions(() => result.map(option => <SelectOption key={option.key} id={option.id} value={option.value}>{option.label}</SelectOption>))
        }
        fetchData();
    }, []);

    return (

        <div className="margin-4-t">
            <div className="row">
                <div className="col-md-12">
                    <Label htmlFor="relativeDropdown">Regulatory Disclosure: Are you a Director or Relative of Director of American Express Banking Corp or any other Bank?</Label>
                    <Select id="relativeDropdown" value={formData.relOfDirector} fluid={true} name="RelativeOfDir" aria-describedby="relative-alert" required={true} onChange={valueChange}>
                        <SelectOption>Select</SelectOption>
                        {options}  
                    </Select>
                    <Alert id="relative-alert" show={errorData.relOfDirectorRequired}>Please select</Alert>
                </div>
            </div>
            
           
            <div>
                <a className="text-underline" onClick={showModal} href="/#">Click here</a> for more details on the definition of such positions.
            </div>
            {show && (
                <div>
                    <Modal onClose={closeModal}>
                        <ModalBody>
                            <div className="pad-4">
                                <div className="container">
                                    <div className="row">
                                        <ul className="stack">
                                            <li className="stack">
                                                As per the Banking Regulation Act, “Director” includes a member of any board or committee in India constituted by a banking company for the purpose of managing, or for the purpose of advising it in regard to the management of, all or any of its affairs.
                                            </li>
                                            <li className="stack">
                                                As per the Master Circular- Loans and Advances – Statutory and Other Restrictions-2015, the scope of the term ‘relative’ will be as under: • Spouse • Father  • Mother (including step-mother) • Son (including step-son) • Son's Wife • Daughter (including step-daughter) • Daughter's Husband • Brother (including step-brother) • Brother’s wife • Sister (including step-sister) • Sister’s husband • Brother (including step-brother) of the spouse • Sister (including step-sister) of the spouse.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button styleType="tertiary" onClick={closeModal}>
                                Hide Details
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )}
        </div>
    );
}
export default RelativeOfDirector;